<template>
  <div>
    <span class="text-body-2 font-weight-medium text-black">
      {{ $t('main.contact_method') }}
    </span>
    <div :class="['d-flex messenger-border', { 'border-error': errorMessage }]">
      <div class="max-width">
        <c-select
          v-if="messengers.length"
          :id="seleniumIds.SELENIUM_TEST_REGISTER_SELECT_MESSENGERS_FIELD"
          v-model="userMessenger"
          :items="messengers"
          item-title="name"
          item-value="id"
          return-object
          height="48px"
          large-text
          bg-color="transparent"
          hide-details
          :loading="messengersAreLoading"
        />
      </div>
      <div class="divider" />
      <div class="stretch">
        <field-nickname
          v-for="(messenger, index) in chosenMessengers"
          :key="messenger.id"
          :index="index"
          :messenger="messenger"
          :chosen-messengers="chosenMessengers"
          @select-messengers="$emit('select-messengers', $event)"
          @set-error="$emit('set-error', $event)"
        />
      </div>
    </div>
    <errors v-if="errorMessage" :error-messages="errorMessage" />
  </div>
</template>

<script>
  import { CSelect, Errors } from '@clickadilla/components/components'
  import { mapState, mapActions } from 'pinia'
  import { seleniumIds } from '@clickadilla/components/constants'
  import { useCollectionsStore } from '@/store/collections/collections'
  import FieldNickname from './FieldNickname.vue'

  export default {
    name: 'SocialNetworks',
    components: {
      Errors,
      FieldNickname,
      CSelect
    },
    props: {
      errors: {
        type: Object,
        default: () => ({})
      },
      chosenMessengers: {
        type: Array,
        default: () => []
      }
    },
    emits: ['select-messengers', 'set-error'],
    data() {
      return {
        seleniumIds
      }
    },
    computed: {
      ...mapState(useCollectionsStore, ['messengers', 'messengersAreLoading']),
      userMessenger: {
        get() {
          return this.chosenMessengers[0]
        },
        set(value) {
          if (this.chosenMessengers[0]?.id === value?.id) {
            return
          }
          this.$emit('select-messengers', [value])
        }
      },
      errorMessage() {
        return this.errors['messengers.0.nickname'] || this.errors.phone || null
      }
    },
    async created() {
      await this.fetchMessengersList()
      if (this.chosenMessengers.length === 0) {
        this.$emit('select-messengers', [this.messengers[0]])
      }
    },
    methods: {
      ...mapActions(useCollectionsStore, ['fetchMessengersList'])
    }
  }
</script>

<style scoped lang="scss">
  .messenger-border {
    position: relative;
    border: 1px solid rgb(var(--v-theme-secondary-200));
    border-radius: 8px;
    height: 48px;
  }
  .border-error {
    border-width: 2px;
    border-color: rgb(var(--v-theme-error));
  }
  .divider {
    width: 1px;
    min-width: 1px;
    height: 100%;
    background-color: rgb(var(--v-theme-secondary-200));
  }
  .max-width {
    width: 40%;
  }
  .stretch {
    flex-grow: 1;
  }
  :deep(.v-field) {
    &:hover .v-field__outline {
      .v-field__outline__start,
      .v-field__outline__end {
        border-color: transparent !important;
      }
    }
    &.v-field--focused .v-field__outline {
      .v-field__outline__start,
      .v-field__outline__end {
        border-color: transparent !important;
      }
    }
  }
</style>
